import React from "react";
import Navbar from "./Navbar";
import Header from "./Header";


const Home = () => {
  return (
    <>
      <Navbar />
      <Header />
    </>
  );
};

export default Home;
